/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Sreality_SellerInputs */

const cs_enum_sreality_seller = /** @type {(inputs: Enum_Sreality_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejce Sreality`)
};

const en_enum_sreality_seller = /** @type {(inputs: Enum_Sreality_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality seller`)
};

/**
* | output |
* | --- |
* | "Sreality seller" |
*
* @param {Enum_Sreality_SellerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sreality_seller = /** @type {((inputs?: Enum_Sreality_SellerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Sreality_SellerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sreality_seller(inputs)
	return cs_enum_sreality_seller(inputs)
});